import { getCurrencySymbol } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { AccountService } from '@banyan/features/account/services/account.service';

@Pipe({
  name: 'defaultCurrency',
  standalone: true,
})
export class DefaultCurrencyPipe implements PipeTransform {
  preferredCurrency: string = 'IDR';
  preferredLanguage: string = 'id-ID';
  accountService = inject(AccountService);

  constructor() {
  }

  transform(val: any, currency?: string): any {
    const defaultCurrencyCode = currency ?? this.accountService.user().preferredCurrency;
    const currencySymbol = getCurrencySymbol(defaultCurrencyCode, 'narrow');
    return new Intl.NumberFormat(this.accountService.user().preferredLanguage, {
      style: 'currency',
      currency: defaultCurrencyCode,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
    }).format(Number(val))
      .replace(defaultCurrencyCode, currencySymbol)
      .replace(/\s/g, '');
  }
}
